import React, { PureComponent } from "react"
import { interpolateRound } from "d3-interpolate"
import { select } from "d3-selection"

export default class ContinuousMetricBox extends PureComponent {
    componentDidUpdate() {
        this.textElement
            .text(0)
            .transition()
            .delay(1000)
            .duration(1000)
            .tween("text", () => {
                const interpolate = interpolateRound(
                    this.textElement.text(),
                    this.props.metric
                )
                return time => {
                    this.textElement.text(interpolate(time))
                }
            })
    }

    componentWillUnmount() {
        this.textElement.interrupt()
    }

    render() {
        return (
            <div className="col col-xs-12 child">
                <div className="widget metric-box">
                    <h4 className="col-xs-10 col-sm-12 text-heading align-text-heading">
                        {this.props.title}
                    </h4>
                    <div className="col-xs-2 col-sm-12 bottom-positioned align-text-metric numeric-metric">
                        <h2
                            className="text-numeric-metric"
                            ref={textElement =>
                                (this.textElement = select(textElement))
                            }
                        >
                            0
                        </h2>
                    </div>
                </div>
            </div>
        )
    }
}
